import PropTypes from "prop-types";

// Logos render up to ~220px (Favy category tables); 2x for retina plus headroom. Keeps Contentful from serving full-resolution originals.
const MAX_WIDTH = 640;

export const BasePictureElement = ({ classNames, src, ...rest }) => {
	const hasContentfulSource =
		src && src.includes("images.ctfassets.net") && !src.includes("?");

	return (
		<picture className={classNames?.picture}>
			{hasContentfulSource ? (
				<>
					<source
						srcSet={`${src}?fm=avif&q=80&w=${MAX_WIDTH}`}
						type="image/avif"
					/>
					<source
						srcSet={`${src}?fm=webp&q=80&w=${MAX_WIDTH}`}
						type="image/webp"
					/>
				</>
			) : null}
			<img
				loading="lazy"
				decoding="async"
				className={classNames?.image}
				src={hasContentfulSource ? `${src}?w=${MAX_WIDTH}` : src}
				{...rest}
			/>
		</picture>
	);
};

BasePictureElement.propTypes = {
	classNames: PropTypes.object,
	src: PropTypes.string,
};
